import generateJavaRequest from './services/jrequest';

const jrequest = generateJavaRequest('order');
const jLinkedMallRequest = generateJavaRequest('linkedmall');
const jfRequest = generateJavaRequest('jifen');

/**
 * 订单结算信息
 * @param condiotions
 * @returns {*}
 */
export function getOrderSettleInfo(condiotions) {
  return jrequest('settleInfo', condiotions);
}

/**
 * 结算计算
 * @param condiotions
 * @returns {*}
 */
export function getOrderCalculateInfo(condiotions) {
  return jrequest('calculate', condiotions, {
    method: 'post',
  });
}

/**
 * 提交订单
 * @param condiotions
 * @returns {*}
 */
export function submitOrder(condiotions) {
  return jrequest('submit', condiotions, {
    method: 'post',
  });
}

/**
 * 提交尾款订单
 * @param condiotions
 * @returns {*}
 */
export function submitRetainageOrder(condiotions) {
  return jrequest('/submit/pre/final', condiotions);
}

/**
 * 获取用户订单列表
 * @param {*} condiotions
 */
export function getUserOrderList(condiotions) {
  return jrequest('list', condiotions);
}

/**
 * 聚宝盆订单列表
 * @param {*} condiotions
 */
export function getUserOrderJbpList(condiotions) {
  return jrequest('jbp/list', condiotions);
}

/**
 * 获取用户订单详情
 * @param {*} condiotions
 */
export function getOrderDetail(condiotions) {
  return jrequest('detail', condiotions);
}

/**
 * 取消订单
 * @param {*} condiotions
 */
export function cancelOrder(condiotions) {
  return jrequest('cancel', condiotions);
}

/**
 * 取消待发货的订单 这个取消是要退钱的
 * @param {*} condiotions
 */
export function refundOrder(condiotions) {
  return jrequest('refund', condiotions, {
    method: 'post',
  });
}

/**
 * 取消退款申请
 * @param {*} condiotions
 */
export function cancelRefundOrder(condiotions) {
  return jrequest('cancel/refund', condiotions);
}

/**
 * 修改订单收货地址
 * @param {*} condiotions
 */
export function editOrderAddress(condiotions) {
  return jrequest('update/address', condiotions, {
    method: 'post',
  });
}

/**
 * 查询订单物流
 * @param {*} condiotions
 */
export function getExpressDetail(condiotions) {
  return jrequest('express', condiotions);
}

/**
 * 订单确认收货
 * @param {*} condiotions
 */
export function confirmOrder(condiotions) {
  return jrequest('confirm', condiotions);
}

/**
 * 售后列表
 * @param {*} condiotions
 */
export function getRefundList(condiotions) {
  return jrequest('refund/list', condiotions);
}

/**
 * 商品申请售后
 * @param {*} condiotions
 */
export function refundApply(condiotions) {
  return jrequest('refund/return', condiotions, {
    method: 'post',
    type: 'form',
  });
}

/**
 * 获取售后商品详情
 * @param {*} condiotions
 */
export function getRefundDetail(condiotions) {
  return jrequest('refund/info', condiotions);
}

/**
 * 取消商品售后
 * @param {*} condiotions
 */
export function cancelRefund(condiotions) {
  return jrequest('refund/cancel', condiotions);
}

/**
 * 用户发货物流
 * @param {*} condiotions
 */
export function submitRefundExpress(condiotions) {
  return jrequest('refund/express', condiotions, {
    method: 'post',
  });
}

/**
 * 售后换货确认收货
 * @param {*} condiotions
 */
export function confirmReceive(condiotions) {
  return jrequest('refund/confirm', condiotions);
}

/**
 * 检查订单抽奖
 * @param {*} condiotions
 */
export function fetchCheckLottery(condiotions) {
  return jrequest('prom/lottery/check', condiotions);
}

/**
 * 订单轮盘抽奖
 * @param {*} condiotions
 */
export function fetchGetLottery(condiotions) {
  return jrequest('prom/lottery', condiotions);
}

/**
 * 盲盒开盒抽奖
 * @param {*} condiotions
 */
export function lettoryBlindBox(condiotions) {
  return jrequest('open/blind', condiotions);
}


/**
 * 检查企业购商品是否可购买
 * @param {*} conditions
 */
export function renderLinkedMallOrder(conditions) {
  return jLinkedMallRequest('renderOrder', conditions);
}

/**
 * 积分商城第三方渠道商品下单前置校验及预下单
 * @param {*} conditions
 */
export function renderJiFenOrder(conditions) {
  return jfRequest('renderOrder', conditions);
}

/**
 * 售后渲染 验证商品是否可进行售后，返回售后原因
 * @param {*} conditions
 */
export function renderRefund(conditions) {
  return jfRequest('renderRefund', conditions);
}

/**
 * 售后渲染 获取商品可售后类型
 * @param {*} conditions
 */
export function renderRefundType(conditions) {
  return jfRequest('renderRefundType', conditions);
}

/**
 * 小芒售后渲染 获取商品是否可售后
 * @param {*} conditions
 */
export function canApplyXMRefund(conditions) {
  return jfRequest('xm/can/refund', conditions);
}
